import { register } from "@shopify/theme-sections";
/*----Smooth scroll to the section by clicking on anchor link----*/
register("listing-nav", {
  anchorHandle() {
    let anchors = this.container.querySelectorAll(".collection-filter__anchor--same-page");

    if (anchors && anchors.length) {
      anchors.forEach((anchor) => {
        anchor.addEventListener("click", (e) => {
          e.preventDefault();
          let section = document.getElementById(
            `hero-${anchor.getAttribute("href").replace("#", "")}`
          );

          let anchoredSection = section
            ? section
            : document.getElementById(
              `products-listing-${anchor
                .getAttribute("href")
                .replace("#", "")}`
            );

          if (anchoredSection) {
            window.scroll({
              top: anchoredSection.offsetTop - 100,
              behavior: "smooth",
            });
          }
        });
      });
    }
  },

  onLoad: function (e) {
    this.anchorHandle();
  },
});
